<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [currentUrl]="currentUrl"></app-breadcrumb>
<!-- section start -->
<section class="wishlist-section section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12" *ngIf="!nodata">
                <table class="table cart-table table-responsive-xs">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">{{'notification-details' | translate}}</th>
                            <th scope="col">{{'Date Added' | translate}}</th>
                            <th scope="col" class="action-head-table">{{'action1' | translate}}</th>

                            <!-- <th scope="col">#</th> -->

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let notification of notificationsList">
                            <td class="notification-content">
                                <p>
                                    {{notification.content ? notification.content : notification.title}}
                                </p>
                            </td>
                            <td class="text-center">
                                {{notification.date_added}}
                            </td>
                            <td class="text-center actions-cell">

                                <a href="javascript:void(0)" class="mr-3 icon" title="حذف"
                                    (click)="openModal(notification.id)">
                                    <i class="ti-trash"></i>

                                </a>
                                <!-- /
                                <a [href]="'pages/notification/'+notification.id" class="mr-3 icon" title="عرض">
                                    <i class="ti-eye"></i>
                                </a> -->
                            </td>
                            <!-- <td>
                                <p># {{notification.id}}</p>
                            </td> -->

                        </tr>
                    </tbody>
                </table>

                <div class="mobile-notifications-layout">

                    
                    <div class="col-sm-12 d-flex justify-content-center loader-block" *ngIf="loading">
                        <img src="assets/images/loader.gif">
                    </div>
                    

                    <div class="mt-5 text-center col-sm-12 section-b-space no-found" *ngIf="!notificationsList.length && !loading">
                        <img src="assets/images/empty-search1.png" class="img-fluid">
                        <h3>{{'no data' | translate}}</h3>
                    </div>

                    <ng-container *ngIf="notificationsList.length && !loading">
                        <div class="single-notification-item" *ngFor="let notification of notificationsList">
                            <div class="d-flex">
                                <!-- <a class="img-block" [routerLink]="['/pages/notification/', notification.id]" > -->
                                <a class="img-block" >
                                    <img *ngIf="notification.page_type == 'productAvailable'" [src]="urlimage + notification.image" alt="">
                                    <img *ngIf="notification.page_status == 'canceled' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-canceled.webp'" alt="Order Canceled">
                                    <img *ngIf="notification.page_status == 'pending' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-pending.webp'" alt="Order Pending">
                                    <img *ngIf="notification.page_status == 'waiting_confirm' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-waiting.webp'" alt="Order Waiting">
                                    <img *ngIf="notification.page_status == 'confirmed' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-confirmed.webp'" alt="Order Confirmed">
                                    <img *ngIf="notification.page_status == 'client_not_responce' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-client-no-respond.webp'" alt="Client Not Responding">
                                    <img *ngIf="notification.page_status == 'under_prepare' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-preparing.webp'" alt="Order Being Prepared">
                                    <img *ngIf="notification.page_status == 'in_delivered' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-delivering.webp'" alt="Order Out For Delivery">
                                    <img *ngIf="notification.page_status == 'delivered' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/order-delivered.webp'" alt="Order Delivered">
                                    <img *ngIf="notification.page_status == 'delivery_failed' && notification.page_type == 'invoice_status'" [src]="'assets/images/icon/Delivery-failed.webp'" alt="Order Delivered">
                                </a>
                                <!-- <a class="content-block" [routerLink]="['/pages/notification/', notification.id]"> -->
                                <a class="content-block">
                                    <span class="title">
                                        {{notification.title}}
                                    </span>
                                    <span class="date">
                                        {{notification.date_added}}
                                    </span>
                                    <span class="content">
                                        {{notification.content}}
                                    </span>
                                </a>
                            </div>
                            
                            <div class="options-block" (click)="openModal(notification.id)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </div>
                        </div>
                    </ng-container>
                    
                    
                </div>
            </div>

            <div class="col-sm-12" *ngIf="nodata">
                <table class="table cart-table table-responsive-xs">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">{{'no data' | translate}}</th>
                        </tr>
                    </thead>

                </table>
            </div>
        </div>
    </div>
</section>
<!--section end-->

<ng-template class="theme-modal" #newsletter let-modal>
    <div class="modal-content">
        <div class="modal-body modal7" style="background-image: unset;">
            <div class="p-0 container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-bg">
                            <button type="button" class="close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="offer-content" *ngIf="step1">
                                <div class="circle-icon">
                                    <i class="ti-info-alt"></i>

                                </div>
                                <h2> {{'Delete' | translate}} </h2>
                                <h4> {{'Do you want to delete the notification' | translate}} </h4>
                                <br>

                                <div class="modal-footer">
                                    <button type="button" class="mr-auto btn btn-primary"
                                        (click)="deleteNotification()">Yes</button>
                                    <button type="button" class="btn btn-secondary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">No</button>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step2">

                                <h2>{{'Delete' | translate}} </h2>

                                <div class="category-image">
                                    <img src="assets/images/slider/loader12.gif" alt="" class="w-auto">
                                </div>

                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <br>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step3">
                                <div class="circle-icon-check">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </div>

                                <h2 class="text-success">{{'Delete notification Successfully' | translate}}</h2>


                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <button type="button" class="mr-auto btn btn-primary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">Ok</button>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>